export default __webpack_public_path__ + "renren-social-network-of-china-logotype.png";